import {
  Box,
  DialogBackdrop,
  DialogContent,
  DialogPositioner,
  DialogRoot,
  Flex,
  chakra,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { UserProfile } from "@greenflagdate/shared";
import { MatchProfile } from "../../pages/marketing/Match/MatchProfile";

export function MatchProfileModal({
  profile,
  onClose,
}: {
  profile: UserProfile | null;
  onClose: () => void;
}) {
  return (
    <DialogRoot
      open={!!profile}
      onOpenChange={(d) => {
        if (!d.open) onClose();
      }}
    >
      <DialogBackdrop />
      <DialogPositioner>
        <DialogContent
          maxW="30rem"
          w="calc(100% - 2rem)"
          mx="auto"
          my="2rem"
          maxH="calc(100dvh - 4rem)"
          borderRadius="xl"
          bg="bg.canvas"
          display="flex"
          flexDirection="column"
          overflow="hidden"
          position="relative"
        >
          <Box flex="1" minH="0" overflowY="auto">
            {profile && <MatchProfile profile={profile} />}
            <Flex h="1rem" flexShrink={0} />
          </Box>
          <chakra.button
            type="button"
            aria-label="Close"
            onClick={onClose}
            position="absolute"
            top="0.75rem"
            right="0.75rem"
            zIndex="100"
            w="2rem"
            h="2rem"
            borderRadius="full"
            bg="blackAlpha.600"
            color="white"
            border="0"
            cursor="pointer"
            display="flex"
            alignItems="center"
            justifyContent="center"
            boxShadow="md"
            _hover={{ bg: "blackAlpha.700" }}
          >
            <FontAwesomeIcon icon={faXmark} />
          </chakra.button>
        </DialogContent>
      </DialogPositioner>
    </DialogRoot>
  );
}
